import PropTypes from 'prop-types';
import blogAttributeShape from './blogAttributeShape';

const blogShape = {
  id: PropTypes.number.isRequired,
  attributes: PropTypes.shape(blogAttributeShape).isRequired,
};

export default blogShape;
